<template>
  <div class="addNewClass">
    <div class="content">
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>洗车门店名称</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.name"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>洗车门店手机号</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.mobile"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>洗车门店地址</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.address"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>位置定位</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <!-- <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.address"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div> -->
                <!--  -->
                <div class="newBoxFlex">
                  <div>
                    经度：<el-input
                      readonly
                      class="point_box"
                      v-model="mapPoint.lng"
                    ></el-input>
                  </div>
                  <div>
                    纬度：<el-input
                      readonly
                      class="point_box"
                      v-model="mapPoint.lat"
                    ></el-input>
                  </div>
                  <el-button @click="showmap = true">选择坐标</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>洗车门店分类</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div >
                  <el-cascader
                    v-model="cateValue"
                    :props="defaultCate"
                    :options="catedata"
                    size="mini"
                  >
                  </el-cascader>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>门店管理</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div>
                  <el-select v-model="form.store_id" placeholder="请选择门店">
                    <el-option
                      v-for="item in shopLists"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row> -->
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>洗车门店图片</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <el-upload
                  name="image"
                  :data="imgdata"
                  class="avatar-uploader"
                  :show-file-list="false"
                  accept="image/jpeg,image/gif,image/png"
                  action="https://www.58zltc.com/api/Upload/uploads/"
                  :on-success="handleLogoSuccess"
                  :before-upload="beforeLogoUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>所需积分</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    type="number"
                    v-model="form.score"
                    placeholder="请输入积分数量"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>是否扫码验证</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <template>
              <el-radio v-model="form.is_verify" label="1">是</el-radio>
              <el-radio v-model="form.is_verify" label="0">否</el-radio>
            </template>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>是否显示</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <template>
              <el-radio v-model="form.status" label="1">是</el-radio>
              <el-radio v-model="form.status" label="0">否</el-radio>
            </template>
          </div>
        </el-col>
      </el-row> -->
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>洗车门店描述 </span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <EditorBar @change="changeeditor" v-model="form.des"></EditorBar>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" justify="end" type="flex" style="margin-bottom:40px">
        <el-col :span="14">
          <el-button type="primary" @click="submit">
            <span>提交</span>
          </el-button>
          <el-button @click="$router.go(-1)">
            取消
          </el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 地图选择 -->
    <el-dialog :visible.sync="showmap" @close="closeMap">
      <div class="map_search">
        <el-input v-model="mapKeyword">
          <template slot="append">
            <el-button @click="searchMap">搜索</el-button>
          </template>
        </el-input>
      </div>
      <Map @getPoint="getpoint" ref="Bmap"></Map>
      <div class="map_button">
        <span>经度：{{ mapPoint.lng }}</span>
        <span>纬度：{{ mapPoint.lat }}</span>
        <div>
          <el-button @click="closeMap()">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Map from "@/components/map/tmap";

import EditorBar from "@Components/public/wangEnduit";
import { mapGetters, mapActions } from "vuex";
import { addRoomWash, editRoomWash, detailRoomWash } from "@/api/carWash";
// import { getCateApi } from "@/api/mall";
import { selectStoreList } from "@/api/storeManage";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    EditorBar,
    Map
  },
  data() {
    return {
      showmap: false, //显示地图
      mapPoint: {},
      mapKeyword: "", //地图关键字搜索
      keyword: "",
      shopLists: [],
      jude: 0,
      // cateValue: "",
      // catedata: [],
      defaultCate: {
        label: "name",
        value: "id"
      },
      imgdata: {},
      imageUrl: "",
      imageIdx: 0,
      form: {
        type: 1, //合作门店类型
        name: "",
        address: "",
        lat: "",
        lng: "",
        cover_id: "", //图 id
        // cate: "", //分类 id
        // store_id: "",
        // score: "",
        des: "", //
        mobile: "",
        status: "1",
        is_verify: "1"
      }
    };
  },
  mounted() {
    this.imgdata = {
      app_id: this.app_id,
      token: this.token,
      type: "1",
      file_group: "1"
    };
    // this.getCate();
    if (this.$route.query.idE) {
      this.jude = this.$route.query.idE;
      this.getDetail();
    }
    this.getShopList();
    console.log("判断jude", this.jude);
  },
  methods: {
    //关闭地图
    closeMap() {
      this.showmap = false;
    },
    //地图选点
    getpoint(e) {
      console.log(e.lng, e.lat);
      this.mapPoint = e;
    },
    //地图搜索
    searchMap() {
      this.$refs.Bmap.search(this.mapKeyword);
    },
    // 门店下拉列表
    getShopList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      selectStoreList(data).then(res => {
        console.log("门店下拉列表", res);
        this.shopLists = res.data;
      });
    },
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.form.cover_id = res.data.id;
        this.imageUrl = URL.createObjectURL(file.raw);
      }
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 获取编辑器内容
    changeeditor(value) {
      console.log("编辑内容", value);
      // this.form.textCon = value;
    },

    submit() {
      // if(typeof(this.cateValue) != "number"){
      //   this.form.cate = this.cateValue[this.cateValue.length - 1];
      // }else{
      //   this.form.cate = this.cateValue;
      // }
      // 图片
      let data = {
        name: this.form.name,
        // cate: this.form.cate, //分类 id
        type: this.form.type,
        address: this.form.address,
        cover_id: this.form.cover_id,
        mobile: this.form.mobile,
        des: this.form.des, //
        notice: this.form.notice, //注意事项
        exchange_process: this.form.exchange_process, //兑换流程
        status: this.form.status,
        is_verify: this.form.is_verify,
        token: this.token,
        lat: this.mapPoint.lat,
        lng: this.mapPoint.lng
      };
      console.log("提交数据", data);
      // return false;
      data.app_id = this.app_id;
      if (this.jude == 0) {
        addRoomWash(data).then(res => {
          console.log("保存洗车门店", res);

          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.$router.go(-1);
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
      } else {
        data.id = this.jude;
        editRoomWash(data).then(res => {
          if (res.code == 0) {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.$router.go(-1);
          }
        });
      }
    },
    // 分类
    // getCate() {
    //   let data = {
    //     token: this.token,
    //     app_id: this.app_id
    //   };
    //   getCateApi(data).then(res => {
    //     console.log("分类数据", res);
    //     if (res.code == 1) {
    //       this.catedata = res.data;
    //     }
    //   });
    // },
    // 洗车门店详情
    getDetail() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: this.jude
      };
      detailRoomWash(data).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.imageUrl = res.data.pic;
          this.form.is_verify = String(this.form.is_verify);
          this.form.status = String(this.form.status);
          this.mapPoint = {
            lat: this.form.lat,
            lng: this.form.lng
          };
          // this.form.store_id = this.form.store_id * 1;
          // this.cateValue = res.data.cate;
          console.log("form", this.form);
        }
        console.log("洗车门店详情", res);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 300px;
}
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #8c939d !important;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.addNewClass {
  height: 100%;
  overflow: auto;
  .content {
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 20px 30px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
    }
    .grid-content {
      line-height: 36px;
      min-height: 36px;
      .label {
        // width: 70px;
        line-height: 20px;
        // height: 20px;
        padding: 5px 15px;
        border-radius: 20px;
        background: rgba(64, 158, 255, 0.1);
        text-align: center;
        margin-right: 10px;
        position: relative;
        .close {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #ff00004f;
          line-height: 15px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    // 新加样式
    .newBoxFlex {
      display: flex;
      > div {
        margin-right: 10px;
      }
      .el-input {
        width: 160px;
      }
    }
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>

<style lang="scss">
.addNewClass {
  .editor {
    width: 100%;
    .text {
      min-height: 220px;
    }
  }
}
</style>
